import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Zap, Droplets, Tv, Receipt } from 'lucide-react';
import MarketingLayout from '../components/marketing/MarketingLayout';
import PageHero from '../components/marketing/PageHero';
import { IMAGES } from '../lib/marketingImages';

const items = [
  {
    icon: Zap,
    title: 'Prepaid electricity',
    photo: IMAGES.heroPower,
    body: 'Buy ESCOM units anytime. Tokens land on your phone so the fridge, lights, and Wi-Fi come back together.',
    providers: 'ESCOM',
  },
  {
    icon: Droplets,
    title: 'Water bills',
    photo: IMAGES.water,
    body: 'Settle your water account from home. Support for Lilongwe, Blantyre, and Northern Region water boards.',
    providers: 'LWB · BWB · NRWB',
  },
  {
    icon: Tv,
    title: 'TV subscriptions',
    photo: IMAGES.tv,
    body: 'Keep DStv and GOtv alive before the big match. We nudge you when a package is about to lapse.',
    providers: 'DStv · GOtv',
  },
  {
    icon: Receipt,
    title: 'Tax & household extras',
    photo: IMAGES.kitchen,
    body: 'MRA tax payments and more household services, using the same simple pay flow you already know.',
    providers: 'MRA · more coming',
  },
];

export default function ServicesPage() {
  const navigate = useNavigate();
  return (
    <MarketingLayout>
      <PageHero
        image={IMAGES.electrician}
        eyebrow="Services"
        title="Everything your home needs to stay on."
        subtitle="One account for electricity, water, TV, and more — designed for people, not procurement teams."
      />
      <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto grid md:grid-cols-2 gap-8">
        {items.map((item) => (
          <article key={item.title} className="bg-card border border-border rounded-3xl overflow-hidden shadow-sm">
            <img src={item.photo} alt="" className="h-52 w-full object-cover" />
            <div className="p-6">
              <div className="w-11 h-11 rounded-xl bg-primary/10 text-primary flex items-center justify-center mb-3">
                <item.icon className="w-5 h-5" />
              </div>
              <h2 className="text-2xl font-bold mb-2">{item.title}</h2>
              <p className="text-muted-foreground mb-3">{item.body}</p>
              <p className="text-xs font-semibold uppercase tracking-wide text-primary mb-4">{item.providers}</p>
              <button
                onClick={() => navigate('/register')}
                className="px-4 py-2 bg-primary text-primary-foreground rounded-xl text-sm font-semibold"
              >
                Start paying
              </button>
            </div>
          </article>
        ))}
      </section>
    </MarketingLayout>
  );
}
